export default function Footer() {
    return (
        <div>
            <img src="/images/CTA + Footer.png" alt="Footer" className="w-full h-[692px] object-contain lg:h-full lg:object-cover"/>
        </div>
    )
}